export enum EducatorStatus {
  Active = 1,
  Inactive = 0,
}

export enum EducatorType {
  ClinicalEducator = 1,
  Other = 2,
  PeerEducator = 3,
}
